import styled from 'styled-components';

export const SiteMapAnchor = styled.a`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.text.interactive};
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.c.text['interactive-hover']};
  }
`;

export const SiteMapAnchorGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.unit(1)};
  column-gap: ${({ theme }) => theme.unit(3)};
  ${p => (p.isMobile ? 'flex-direction: column;' : '')};
`;
